import { Navigate } from "react-router-dom";

import { BillingPage } from "@src/deprecated/pages/Billing";
import { navigation } from "@src/shared/navigation";
import { useActor } from "@src/shared/providers/actorProvider";

export function meta() {
  return [
    { title: "Billing" },
    { name: "description", content: "Billing page" },
  ];
}

export default function Billing() {
  const actor = useActor();

  if (actor.type !== "physician") {
    return <Navigate to={navigation.patients()} replace />;
  }

  return <BillingPage />;
}
